import { createPageApp } from '@/lib/createPageApp'
import ShowcasePage from './ShowcasePage.vue'

createPageApp(ShowcasePage).mount()
